module.exports = __webpack_public_path__ + "img/phone-blue.9477432b.svg";